<template>

<section class='collection collection--carousel'>
    <div class='collection__grid grid'>
        <div class='collection__grid__col grid__col'>
            <div ref='content' class='collection__content'>

                <router-link v-if='isShowHeading && isLinkTitle' class='collection__heading collection__heading--is-link collection__heading--small' :class='{"collection__heading--is-title-case": isTitleCase, "collection__heading--has-link": isShowViewCollectionLink}' :to='{ name: "collection", params: { slug: slug }}'>
                    <h2 ref='title'
                        class='collection__heading__title collection__heading__title--1'
                        v-text='collection?.title || "Collection"'
                    />

                    <!-- duplicate title for glow; html gets set after text fitting -->
                    <h2 class='collection__heading__title collection__heading__title--2'
                        v-text='collection?.title || "Collection"'
                    />
                </router-link>
                <h2 v-else-if='isShowHeading' class='collection__heading collection__heading--small' :class='{"collection__heading--is-title-case": isTitleCase, "collection__heading--has-link": isShowViewCollectionLink}'>
                    <h2 ref='title'
                        class='collection__heading__title collection__heading__title--1'
                        v-text='collection?.title || "Collection"'
                    />

                    <!-- duplicate title for glow; html gets set after text fitting -->
                    <h2 class='collection__heading__title collection__heading__title--2'
                        v-text='collection?.title || "Collection"'
                    />
                </h2>

                <router-link
                    v-if='isShowViewCollectionLink'
                    class='collection__view-all'
                    :to='{ name: "collection", params: { slug: slug }}'
                    :aria-label='`View the ${collection.title} collection`'
                    v-text='"View collection"'
                />

                <transition name="vue-fade">
                    <Spinner
                        v-if='!collection'
                        :variants='["large", "absolute"]'
                    />

                    <Swiper
                        v-else
                        class='collection__swiper'
                        @afterInit='onSwiperInit'
                        :slidesPerView='"auto"'
                        :rewind='false'
                        :pagination='{
                            clickable: true,
                            type: "progressbar"
                        }'
                        :navigation='true'
                        :modules='swiperModules'
                        :mousewheel='{
                            enabled: true,
                            forceToAxis: true
                        }'
                        :observer='true'>

                        <SwiperSlide v-for='(item, i) in products' :key='`item-${i}`'>
                            <ProductThumb
                                :handle='item.handle'
                                :media='item.media'
                                :title='item.title'
                                :available='item.available'
                                :price='item.price'
                                :id='item.id'
                                :isNotShowAsSoldOut='productsToNotShowAsSoldout.some(p => p.id === item.id)'
                                :cta='productsCta[item.id]' />
                        </SwiperSlide>
                    </Swiper>
                </transition>


            </div>


        </div>
    </div>
</section>

</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination, A11y, Mousewheel } from 'swiper'

import Spinner from '^/components/elements/Spinner.vue'
import ProductThumb from '^/components/elements/ProductThumb.vue'

export default {
    name: 'CollectionCarouselTier',
    props: {
        slug: {
            type: String,
            required: true
        },
        isShowHeading: {
            type: Boolean,
            default: false
        },
        isLinkTitle: {
            type: Boolean,
            default: false
        },
        // show a "View collection" link under the heading that goes to
        // the full collection page
        isShowViewLink: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        collection: null,
        products: [],
        productsCta: {},
        productsToNotShowAsSoldout: [],

        isTitleCase: true,

        swiper: null,
        swiperModules: [Navigation, Pagination, A11y, Mousewheel]
    }),
    computed: {
        isShowViewCollectionLink () {
            // wait for the collection so the link appears with the heading, not before it
            return this.isShowHeading && !!this.collection && this.isShowViewLink
        }
    },
    created () {
        fetch(`/collections/${this.slug}?view=json`).then(response => {
            return response.json()
        }).then(data => {
            this.collection = data.collection
            this.products = data.products
            this.productsCta = data.products_cta || {}
            this.productsToNotShowAsSoldout = data.products_to_not_show_as_soldout || []
        })
    },
    methods: {
        onSwiperInit (swiper) {
            this.swiper = swiper
        }
    },
    components: {
        Spinner,
        Swiper,
        SwiperSlide,
        ProductThumb
    }
};
</script>
